import { CoreStatusExtended } from 'types';

export const allPathwayHandler = (stages: CoreStatusExtended[]) => {
  return stages.filter(stage => stage !== CoreStatusExtended.PATHWAY_REVIEW);
};
